<template>
  <main>
    <section class="fk-contents">
      <h2 class="title-lv2 mb20">{{$t('Cart.Heading')}}</h2>
      <div class="mod-selected-store">
        <span class="label">{{$t('Cart.ReceiveStore')}}</span>
        <div class="mod-selected-store-wrap mod-general-box">
          <div class="mod-selected-store-name">
            <img :src="importImageUri(getSelectStore.image_url)" :alt="getBrandName(getSelectStore.store_type)">
            <span class="name">{{getSelectStore.store_name}}</span>
          </div>
        </div>
      </div>
      <div class="mod-has-label">
        <span class="label">{{$t('Cart.ReceiveMethod')}}</span>
        <div class="mod-normal-box">
          <h3 class="title-lv3">{{getTextReceiveMethod()}}</h3>
          <p class="mod-form-btn"><a href="#" class="btn-base btn-negative" @click.prevent="changeReceiveMethod($event)">{{$t('Cart.Change')}}</a></p>
        </div>
      </div>
      <div class="mod-has-label">
        <span class="label">{{$t('Cart.OrderDetail')}}</span>
        <div class="mod-normal-box">
          <div class="order-detail-wrap">
            <!-- *** 商品 *** -->
            <div class="order-detail-item" v-for="(order, index) in orderList" :key="index">
              <h3 class="item-coupon-use" v-if="order.isUseCoupon">{{text.UseCoupon}}</h3>
              <h3 class="item-name"><span v-html="order.orderName"></span></h3>
              <div class="spinner-num">
                <div class="button minus js-spinner" data-formula="-" @touchstart="tapCountButton" @touchend="counter($event, index)" @mousedown="tapCountButton" @mouseup="counter($event, index)" @mousemove="counter($event, index)" @mouseleave="counter($event, index)" >{{$t('General.Minus')}}</div>
                <input type="number" name="" id="counter1" :value="order.quantity" class="num" data-max="99" data-min="1" @change="inputQuantity($event, index)" @blur="calculation">
                <div class="button plus js-spinner" data-formula="+" @touchstart="tapCountButton" @touchend="counter($event, index)" @mousedown="tapCountButton" @mouseup="counter($event, index)" @mousemove="counter($event, index)" @mouseleave="counter($event, index)">{{$t('General.Plus')}}</div>
              </div>
              <p class="validation-error align-right" v-if="errors.quantity.length > 0 && errors.quantity[index].msg !== null">{{errors.quantity[index].msg}}</p>
              <p class="order-price"><strong>¥{{displayThousandsSeparator(order.orderPrice)}}</strong><small>{{getTaxDisplay(order.taxType)}}</small></p>
              <ul class="btn-order-detail">
                <li><a href="#" class="btn-base btn-negative" @click.prevent="deleteItem($event, index)">{{$t('General.Delete')}}</a></li>
                <li :class="order.isSelectable || 'hidden'"><a href="#" class="btn-base btn-negative" @click.prevent="detailChange($event, index)">{{$t('Cart.DetailChange')}}</a></li>
              </ul>
              <em v-if="order.isNonTarget">{{text.CouponExcluded}}</em>
            </div>
            <!-- *** 商品 *** -->
            <!-- *** 会計割引クーポン *** -->
            <div class="order-detail-item" v-if="model.accountingCoupon.isUse">
              <h3 class="item-coupon-use">{{text.UseCoupon}}</h3>
              <h3 class="item-name">{{model.accountingCoupon.title}}</h3>
              <p class="order-price"><strong>¥{{displayThousandsSeparator(model.accountingCoupon.discountPrice)}}</strong><small>{{getTaxDisplay(model.accountingCoupon.taxType)}}</small></p>
              <ul class="btn-order-detail">
                <li><a href="#" class="btn-base btn-negative" @click.prevent="deleteItem($event, 'coupon')">{{$t('General.Delete')}}</a></li>
              </ul>
              <em v-if="!model.accountingCoupon.isApplying">{{text.NotApplying}}</em>
            </div>
            <!-- *** 会計割引クーポン *** -->

            <p class="total-price">
              <small>{{$t('General.Total')}}</small>
              <strong>¥{{displayThousandsSeparator(totalPrice)}}</strong>
              <small>{{getTaxDisplay(taxType)}}</small>
            </p>
          </div>
        </div>
      </div>
      <p class="mod-form-btn"><a href="#" class="btn-base btn-sub" @click.prevent="addItem">{{$t('Cart.AddingSelect')}}</a></p>

      <div class="order-decision">
        <p class="caution-text" v-html="genPrivacyTerms()"></p>
        <p class="agree-check"><input type="checkbox" name="" id="agree" v-model="agreement "><label for="agree">{{$t('Cart.Accept')}}</label></p>
        <div class="mod-form-block">
          <span class="label">{{$t('UserLogin.MailAddress')}}</span>
          <input type="email" name="" id="" v-model="mailaddress">
          <span class="validation-error" v-if="errors.mailaddress !== null">{{errors.mailaddress}}</span>
        </div>
        <p class="caution-text" v-html="$t('Cart.EmailAttention')"></p>
        <p class="mod-form-btn"><input type="submit" :value="$t('Cart.DeterminingOrder')" class="btn-base btn-main pointer" @click.prevent="executeDetermination" :disabled="!agreement"></p>
      </div>
    </section>
  </main>
</template>

<script>
import CommonMixin from '@/mixins/CommonMixin'
import ValidationMixin from '@/mixins/ValidationMixin'
import DisplayErrorMixin from '@/mixins/DisplayErrorMixin'
import MultipostAvoidableMixin from '@/mixins/MultipostAvoidableMixin'
import UserAgentMixin from '@/mixins/UserAgentMixin'
import { forEach, join } from 'lodash'
let arySpinner = []
export default {
  name: 'FKMOCart',
  mixins: [ CommonMixin, ValidationMixin, DisplayErrorMixin, MultipostAvoidableMixin, UserAgentMixin ],
  data () {
    return {
      orderList: [],
      totalPrice: 0,
      taxType: null,
      agreement: false,
      mailaddress: null,
      errors: {
        mailaddress: null,
        quantity: []
      },
      doChangingQuantity: false, // 個数更新中の場合
      doExecCalculation: false,
      bufferOrderList: null,
      mouseControll: {
        pointer: {
          sX: 0,
          sY: 0,
          eX: 0,
          eY: 0
        },
        isFlicked: false,
        touchTriggered: false, // toucheventで発火する場合はtrue
        isTouchMoveFired: false // touchmoveが発火している間はtrue
      },
      model: {
        accountingCoupon: {
          isUse: false,
          couponCd: null,
          title: null,
          discountPrice: 0,
          taxType: null,
          isApplying: true // クーポン適用不可フラグ
        },
        amountId: null
      },
      text: {
        CouponExcluded: null,
        NotApplying: null,
        UseCoupon: null
      },
      isScroll: false, // スクロール中はtrue
      isTouchCounterButton: false, // カウントボタンをに触っているときはtrue
      bufferCalcResult: null,
      reqApiTimer: null, // 金額計算実行中フラグの監視タイマー
      doRequestCalcApi: false // 金額計算実行中フラグ
    }
  },
  computed: {
    getSelectStore () {
      return this.$store.getters.selectStore
    },
    getServerTime () {
      return this.$store.getters.serverTime
    },
    getCart () {
      return this.$store.getters.cart
    },
    getOrderDetail () {
      return this.$store.getters.orderDetail
    },
    getDisabledButton () {
      return this.$store.getters.disabledButton
    }
  },
  methods: {
    // 金額計算APIのPOSTパラメータを生成する
    getCalcurationApiParams: function () {
      let params = {
        'item_list': [],
        'receive_method': Number(this.getCart.receive_method),
        'accounting_coupon_cd': null
      }
      // 会計割引クーポンをパラメータに追加する
      if (this.getCart.accounting_coupon !== null) {
        params.accounting_coupon_cd = this.getCart.accounting_coupon.coupon_cd
      }

      // item_listを生成
      let cart = this.getCart
      for (let i = 0; i < cart.item_list.length; i++) {
        let order = cart.item_list[i]
        let quantity = cart.item_list[i].quantity
        // orderListが生成されている場合、orderListから個数を取得する
        if (this.orderList.length > 0) {
          quantity = this.orderList[i].quantity
        }

        let item = {
          'setmenu_cd': null,
          'items': [],
          quantity,
          'coupon_cd': order.coupon_cd || ''
        }
        if (order.item.item_type === 1) {
          // 単品
          // setmenu_cd:items.item_cd = 商品CD:商品CD
          item.setmenu_cd = order.item.category_cd
          item.items.push({ 'item_cd': order.item.category_cd })
        } else {
          // セット
          item.setmenu_cd = order.setmenu.category_cd

          // 単体商品の場合は商品コードをitemsにセットする
          if (order.setmenu_details.length === 0) {
            item.items.push({ 'item_cd': order.setmenu.category_cd })
          } else {
            for (var n = 0; n < order.setmenu_details.length; n++) {
              item.items.push({ 'item_cd': order.setmenu_details[n].item_cd })
            }
          }
        }
        params.item_list.push(item)
      }

      return params
    },

    // カウントボタンが押下されたとき
    tapCountButton: function () {
      this.isTouchCounterButton = true
    },

    // スクロール中の処理(isScrollがtrueの場合は、スクロール中のためカウントを増減させないようにする)
    execScroll: function () {
      if (this.isTouchCounterButton) {
        this.isScroll = true
      }
    },

    /** Spinner処理 ここから ********************************** */
    // カウンターの処理（フリック検知）
    counter: function (event, index) {
      try {
        let _that = this
        // カウント開始
        const countStart = (event, index, formula, position) => {
          // マウスの始点を記録する
          this.mouseControll = {
            pointer: {
              sX: position.sX,
              sY: position.sY,
              eX: 0,
              eY: 0
            },
            isFlicked: false,
            touchTriggered: event.type === 'touchend' || false
          }
          if (formula === '+') {
            _that.countUp(event, index)
          } else {
            _that.countDown(event, index)
          }
        }
        // フリック検知
        const detectFlick = (position) => {
          // sX,sYともに0の場合はクリックされてないのでフリック判定を行わない
          // （ボタンの配置座標から始点座標がsX=0,sY=0になることはありえない）
          if (_that.mouseControll.pointer.sX === 0 && _that.mouseControll.pointer.sY === 0) {
            return false
          }
          _that.mouseControll.pointer.eX = position.eX
          _that.mouseControll.pointer.eY = position.eY
          let moveX = Math.abs(_that.mouseControll.pointer.sX - _that.mouseControll.pointer.eX)
          let moveY = Math.abs(_that.mouseControll.pointer.sY - _that.mouseControll.pointer.eY)
          // X軸、Y軸で設定値以上の移動を検知した場合はフリックしたと判定する
          if (moveX >= 3 || moveY >= 1) {
            _that.mouseControll.isFlicked = true
          }
        }
        switch (event.type) {
          case 'touchend':
            this.isTouchCounterButton = false
            // スクロール中の場合は、処理を実行させない
            if (this.isScroll) {
              this.isScroll = false
              this.mouseControll.isTouchMoveFired = true
              break
            }
            // touchmoveイベントの検知フラグが立っているか
            if (this.mouseControll.isTouchMoveFired) {
              /**
               * NOTE 検知している場合はフラグを倒し、フリック検知をスキップする
               * 以下の条件でtouchendを検知した時の動きを示します。
               * ・200msより短い：（フリック動作）
               *   touchend→setTimeoutの順で発火するため、1回だけカウントアップする
               *   setTimeoutが発火するタイミングでは、isTouchMoveFiredは倒れている。
               * ・200msより長い：（スワイプ動作）
               *   setTimeout→touchendの順で発火するため、setTimeoutが発火した時はisTouchMoveFiredは立っている。
               *   この場合はカウントアップしないでreturnする。
               */
              this.mouseControll.isTouchMoveFired = false
            } else {
              detectFlick({ eX: event.changedTouches[0].clientX, eY: event.changedTouches[0].clientY })
            }
            countStart(event, index, event.target.dataset.formula, { sX: event.clientX, sY: event.clientY })
            this.stopSpinner(event, index)
            break
          case 'mouseup':
            this.isTouchCounterButton = false
            if (this.isScroll) {
              this.isScroll = false
              break
            }
            if (this.mouseControll.touchTriggered) {
              event.preventDefault()
              return false
            }
            countStart(event, index, event.target.dataset.formula, { sX: event.clientX, sY: event.clientY })
            this.stopSpinner(event, index)
            break
          case 'mousemove':
            detectFlick({ eX: event.clientX, eY: event.clientY })
            break
          case 'mouseleave':
            if (this.mouseControll.touchTriggered) {
              event.preventDefault()
              return false
            }
            if (this.mouseControll.isFlicked) {
              this.stopSpinner(event, index)
            }
            break
          default:
            // clickイベントでは処理を発火しない
            break
        }
      } catch (ex) {
        this.errorFromApp(ex)
      }
    },
    // 個数変更処理
    countUp: function (event, index) {
      if (arySpinner['interval']) return false
      // 初期化
      const _that = this
      let cal = 1
      arySpinner['timestamp'] = event.timeStamp
      // 個数更新中フラグを立てる
      this.doChangingQuantity = true
      // クリックイベントを検知
      if (event.type === 'click') {
        this.spinnerCalc(cal, index)
        arySpinner = []
        return false
      }

      // マウスダウン、タッチダウンがホールドされている
      setTimeout(function () {
        // flickフラグが倒れていたらSpinnerを開始
        if (!_that.mouseControll.isFlicked) {
          _that.spinnerCalc(cal, index)
          if (!arySpinner['interval'] && arySpinner['timestamp'] === event.timeStamp) {
            arySpinner['interval'] = window.setInterval(function () {
              _that.spinnerCalc(cal, index)
            }, 20)
          }
        } else {
          _that.spinnerCalc(cal, index)
          arySpinner = []
        }
      }, 200)
    },
    countDown: function (event, index) {
      if (arySpinner['interval']) return false
      // 初期化
      const _that = this
      let cal = -1
      arySpinner['timestamp'] = event.timeStamp
      // 個数更新中フラグを立てる
      this.doChangingQuantity = true
      // クリックイベントを検知
      if (event.type === 'click') {
        this.spinnerCalc(cal, index)
        arySpinner = []
        return false
      }
      // マウスダウン、タッチダウンがホールドされている
      setTimeout(function () {
        // flickフラグが倒れていたらSpinnerを開始
        if (!_that.mouseControll.isFlicked) {
          _that.spinnerCalc(cal, index)
          if (!arySpinner['interval'] && arySpinner['timestamp'] === event.timeStamp) {
            arySpinner['interval'] = window.setInterval(function () {
              _that.spinnerCalc(cal, index)
            }, 20)
          }
        } else {
          _that.spinnerCalc(cal, index)
          arySpinner = []
        }
      }, 200)
    },
    // Spinner計算処理
    spinnerCalc: function (num, index) {
      // orderListをJSONに変換してbufferに退避する
      if (this.bufferOrderList === null) {
        this.bufferOrderList = JSON.stringify(this.orderList)
      }

      if (this.mouseControll.isTouchMoveFired) {
        return false
      }

      if (num === 1) {
        if (this.orderList[index].quantity < 99) {
          this.orderList[index].quantity += 1
        }
      } else if (num === -1) {
        if (this.orderList[index].quantity > 1) {
          this.orderList[index].quantity -= 1
        }
      }

      // orderListとbufferOrderListを比較する
      if (JSON.stringify(this.orderList) === this.bufferOrderList) {
        // 変更がなければ実行フラグを倒す
        this.doExecCalculation = false
        this.$store.dispatch('setDisabledButton', false)
      } else {
        // 変更があれば実行フラグを立てる
        this.doExecCalculation = true
      }

      // store.cartを更新
      const cart = this.getCart
      cart.item_list[index].quantity = this.orderList[index].quantity
      this.$store.dispatch('setCart', cart)
      // App.vueの更新フラグを立てる（バッジを更新）
      this.$parent.updated = true

      // 個数更新中フラグをおろす
      this.doChangingQuantity = false
    },
    // Spinner停止
    async stopSpinner (event, index) {
      // arySpinnerタイマーを停止する
      if (arySpinner['interval']) {
        clearInterval(arySpinner['interval'])
      }
      arySpinner = []

      let _that = this
      // ボタンを非活性化
      this.setDisabledButton(true)
      this.avoidMultipost(async () => {
        // doChangingQuantityフラグを監視する。
        // フラグが下がっていたらリクエストを実行すること
        if (!this.doChangingQuantity && this.doExecCalculation) {
          this.doRequestCalcApi = true
          // 金額更新処理（金額計算API）
          this.callApi('AmountCalculation',
            this.getCalcurationApiParams()
          )
            .then(function (res) {
              if (res.data.result) {
                // 金額計算結果IDを保持する
                if (res.data.value.amount_id === undefined) {
                  _that.model.amountId = null
                } else {
                  _that.model.amountId = res.data.value.amount_id
                }

                // 小計を各商品に割り当てる
                _that.orderList[index].orderPrice = res.data.value.item_list[index].price
                _that.totalPrice = res.data.value.total_price

                // 会計割引クーポンがある場合は割引率を更新
                if (res.data.value.accounting_coupon !== null && res.data.value.accounting_coupon !== undefined) {
                  _that.model.accountingCoupon = _that.displayAccountingCoupon(res.data.value.accounting_coupon.discount_price, res.data.value.tax_type)
                }
              } else {
                _that.errorFromApi(res.data.errorCode, res.data.error)
              }
            })
            .catch((error) => {
              _that.errorFromAxios(error)
            })
            .finally(() => {
              _that.bufferOrderList = null
              _that.setDisabledButton(false) // APIリクエストが完了したらボタンを活性化する
              // フラグを倒す
              _that.mouseControll.isFlicked = false
              _that.mouseControll.touchTriggered = false
              _that.doRequestCalcApi = false
              _that.doExecCalculation = false
            })
        }
      })
        .finally(() => {
          // スワイプで上がりっぱなしになる連打防止フラグを倒す
          if (_that.mouseControll.touchTriggered && !_that.doExecCalculation && !_that.doRequestCalcApi) {
            _that.setDisabledButton(false)
          }
          // APIリクエストをしない場合に限ってmouseleave発火後に立ててしまうフラグを倒す
          if (!_that.doChangingQuantity && !_that.doExecCalculation) {
            _that.setDisabledButton(false)
          }
        })
    },
    /** Spinner処理 ここまで ********************************** */
    // 個数を手入力する
    inputQuantity: function (event, index) {
      if (Number(event.target.value) < 1) {
        event.target.value = '1'
      } else if (Number(event.target.value) > 99) {
        event.target.value = '99'
      }

      this.orderList[index].quantity = Number(event.target.value)
      // store.cartを更新
      const cart = this.getCart
      cart.item_list[index].quantity = Number(event.target.value)
      this.$store.dispatch('setCart', cart)
      // App.vueの更新フラグを立てる（バッジを更新）
      this.$parent.updated = true
    },
    // 商品を削除するボタン
    deleteItem: function (event, id) {
      if (this.getDisabledButton) {
        return null
      }

      let cart = this.getCart
      const _that = this
      if (id === 'coupon') {
        // 会計割引クーポンを削除する
        // モデルから削除
        this.model.accountingCoupon = {
          isUse: false,
          couponCd: null,
          title: null,
          discountPrice: 0,
          taxType: null,
          isApplying: true
        }
        // カートから削除
        cart.accounting_coupon = null
        this.$store.dispatch('setCart', cart)
      } else {
        // orderListから指定番地のアイテムを削除
        this.orderList.splice(id, 1)

        // カートから指定番地のアイテムを削除
        cart.item_list.splice(id, 1)
        // store.cartを更新
        this.$store.dispatch('setCart', cart)
        // 合計金額を更新
        if (this.getCart.item_list.length === 0) {
          this.reqApiTimer = setInterval(() => {
            if (!_that.doRequestCalcApi) {
              this.orderList = []
              this.totalPrice = 0
              window.clearInterval(this.reqApiTimer)
              this.reqApiTimer = null
            }
            // 会計金額クーポンがある場合は値引き額を0に更新する
            if (cart.accounting_coupon !== null) {
              _that.model.accountingCoupon = this.displayAccountingCoupon(0, null)
            }
          }, 200)
          // item_listの個数が0なので金額計算を実行しない
          return
        }
      }
      // 再描画
      this.calculation()
    },
    // 商品を追加するボタン
    addItem: function (event) {
      if (this.getDisabledButton) {
        return null
      }
      this.$router.push({ name: 'MenuCategory' })
    },
    // 注文を確定するボタン
    executeDetermination: async function () {
      // カートの商品数をチェックする
      if (this.getCart.item_list.length === 0) {
        window.commonAlert(this.$i18n.t('ErrorMsg.ERR_021'))
        return false
      }

      // メールアドレスのバリデーション
      let validation = this.validMailaddress(this.mailaddress)
      this.errors.mailaddress = validation.errors.mailaddress
      // 個数のバリデーション（orderListを見て個数が正しくセットされているかを検証する）
      for (let i = 0; i < this.orderList.length; i++) {
        let validQuantity = this.validQuantity(this.orderList[i].quantity)
        if (validation.isValid && !validQuantity.isValid) {
          validation.isValid = validQuantity.isValid
        }
        this.errors.quantity[i].msg = validQuantity.errors.quantity
      }
      if (!validation.isValid) {
        return false
      }
      // カートの商品情報をハッシュ化してセッションストレージに保存
      sessionStorage.setItem('confirmCart', this.CryptoJS.AES.encrypt(JSON.stringify(this.getCart), process.env.VUE_APP_CART_HASHKEY).toString())

      // メールアドレスが未入力の時はconfirmを表示する
      if (this.mailaddress === null || this.mailaddress === undefined || this.mailaddress.length === 0) {
        if (!(await window.commonConfirm({
          'text': this.$i18n.t('Cart.EmailAttentionDialog'),
          'textYes': this.$i18n.t('Cart.EmailAttentionDialogYes'),
          'textNo': this.$i18n.t('Cart.EmailAttentionDialogNo')
        }))) {
          // いいえを選んだら処理を中断
          return false
        }
      }

      // 入力したメールアドレスをsessionStorageに保存
      if (this.mailaddress !== null && this.mailaddress !== undefined && this.mailaddress.length > 0) {
        // encryptする
        sessionStorage.setItem('email', this.CryptoJS.AES.encrypt(this.mailaddress, process.env.VUE_APP_EMAIL_HASHKEY).toString())
      } else {
        sessionStorage.removeItem('email')
      }

      if (this.getDisabledButton) {
        return null
      }
      // ボタンを非活性化
      this.setDisabledButton(true)

      // 注文内容確定API
      let that = this
      let params = {
        'store_cd': this.getSelectStore.store_cd,
        'mail_address': this.mailaddress,
        'menu_category_type': null,
        'language': sessionStorage.getItem('lang'),
        'amount_id': this.model.amountId
      }

      // menu_category_typeを確定
      params.menu_category_type = this.getCart.menu_category_type
      // カートにセットする個数を確定する
      const cart = this.getCart
      for (let i = 0; i < cart.item_list.length; i++) {
        cart.item_list[i].quantity = this.orderList[i].quantity // 個数を取得する
      }
      // store.cartを更新する
      that.$store.dispatch('setCart', cart)

      this.callApi('OrderConfirm',
        params
      )
        .then(function (res) {
          if (res.data.result) {
            // 注文ID更新
            let orderDetail = that.getOrderDetail
            orderDetail.orderId = res.data.value.order_id
            that.$store.dispatch('setOrderDetail', orderDetail)

            that.$router.push({ name: 'OrderFixing' })
          } else {
            that.errorFromApi(res.data.errorCode, res.data.error)
          }
        })
        .catch((error) => {
          that.errorFromAxios(error)
        })
        .finally(() => {
          that.setDisabledButton(false)
        })
    },
    // 内容変更
    detailChange: function (event, id) {
      if (this.getDisabledButton) {
        return null
      }
      sessionStorage.setItem('changeCartNumber', id)
      this.$router.push({ name: 'SetMenuDetail' })
    },
    // 受取方法変更
    changeReceiveMethod: function (event) {
      if (this.getDisabledButton) {
        return null
      }
      sessionStorage.setItem('changeReceiveMethod', true)
      this.$router.push({ name: 'ReceiveMethod' })
    },
    // 金額計算処理
    calculation: function () {
      // 会計割引クーポンだけカートに追加されている場合
      if (this.getCart.item_list.length === 0) {
        // 割引対象がないので固定値をセットする
        this.model.accountingCoupon = this.displayAccountingCoupon(0, null)
        this.totalPrice = 0
        return null
      }

      if (this.GetBrowser() === 'safari' && this.$route.params.requestBlock === '1') {
        return null
      }

      // axios callback内からの参照用
      const _that = this

      // 新しい注文明細
      let newOrderList = []
      // 金額計算実行中フラグを立てる
      this.doRequestCalcApi = true
      // 金額計算APIを実行する
      this.callApi('AmountCalculation',
        this.getCalcurationApiParams()
      )
      // this.axios.get('/static/stub/Cart/cart_calculation.json')
        .then(function (res) {
          if (res.data.result) {
            // 金額計算結果IDを保持
            if (res.data.value.amount_id === undefined) {
              _that.model.amountId = null
            } else {
              _that.model.amountId = res.data.value.amount_id
            }

            for (var i in _that.getCart.item_list) {
              let order = _that.getCart.item_list[i]
              // 商品名を連結する
              let orderName = _that.jointItemName(order)

              // 金額（小計）を取得する
              let orderPrice = res.data.value.item_list[i].price

              let quantity = order.quantity
              // orderListが生成されている時はorderListから個数を取得する
              if (_that.orderList.length > 0) {
                quantity = _that.orderList[i].quantity
              }

              // 税区分を設定
              let taxType = res.data.value.tax_type

              // 構成情報変更フラグ
              let isSelectable = order.isSelectable

              /** ↓↓↓クーポン利用フラグ */
              // セット割引商品フラグの設定をする
              // 小計値割引禁止フラグを参照して、全てのフラグがtrueであればクーポン割引をしているものとみなす
              let isUseCoupon = false
              // 小計値割引禁止フラグの状態をチェックする
              for (let h = 0; h < order.setmenu_details.length; h++) {
                isUseCoupon = order.setmenu_details[h].is_prohibition_discount
                // 小計値割引禁止フラグがfalseの商品が混じっている場合はクーポン使用とはみなさない
                if (!order.setmenu_details[h].is_prohibition_discount) {
                  break
                }
              }
              if (order.coupon_cd === null) {
                // 小計値割引禁止フラグが立っているがクーポンコードがない商品は一般商品
                if (isUseCoupon) {
                  isUseCoupon = false
                }
              } else {
                // クーポンコードが割り振られている単品の商品（サイドメニュー等）
                if (order.setmenu_details.length === 0) {
                  isUseCoupon = true
                }
              }

              // 会計割引クーポンを使っている時に対象外表示をするかを判定する
              let isNonTarget = false
              if (_that.getCart.accounting_coupon !== null) {
                // セット割引クーポンの場合、会計割引クーポンの対象外表示をする
                if (isUseCoupon) {
                  isNonTarget = true
                } else {
                  // レギュラー商品の場合
                  // 小計値割引禁止フラグがすべてtrue→割引禁止なので会計割引クーポンの対象外表示をする
                  // 小計値割引禁止フラグが1つでもfalse→割引可能なので対象外表示をしない
                  for (let h = 0; h < order.setmenu_details.length; h++) {
                    isNonTarget = order.setmenu_details[h].is_prohibition_discount
                    if (!order.setmenu_details[h].is_prohibition_discount) {
                      break
                    }
                  }
                }
              }
              /** ↑↑↑クーポン利用フラグ */

              newOrderList.push({
                orderName,
                orderPrice,
                quantity,
                taxType,
                isSelectable,
                isUseCoupon, // 「クーポン利用」文言表示
                isNonTarget // 会計割引対象外文言表示
              })
            }

            // orderListを更新
            _that.orderList = newOrderList
            // accountingCouponを更新
            if (res.data.value.accounting_coupon !== null && res.data.value.accounting_coupon !== undefined) {
              _that.model.accountingCoupon = _that.displayAccountingCoupon(res.data.value.accounting_coupon.discount_price, res.data.value.tax_type)
            }
            // 合計金額
            _that.totalPrice = res.data.value.total_price
            // 税区分
            _that.taxType = res.data.value.tax_type
          } else {
            _that.errorFromApi(res.data.errorCode, res.data.error)
          }
        })
        .catch((error) => {
          _that.errorFromAxios(error)
        })
        .finally(() => {
          _that.setDisabledButton(false)
          _that.doRequestCalcApi = false
          _that.setEventToSpinners()
        })
    },
    // スピナーボタンにイベントを設定する
    setEventToSpinners: function () {
      try {
        const _that = this
        const el = this.$el.querySelectorAll('.js-spinner')
        for (let i = 0; i < el.length; i++) {
          el[i].addEventListener('touchmove', (ev) => {
            _that.mouseControll.isTouchMoveFired = true
          })
        }
      } catch (ex) {
        this.errorFromApp(null, ex)
      }
    },
    // 個人情報の取得・利用の本文のハイパーリンクを生成する
    genPrivacyTerms: function () {
      // 戻り値
      let ret = []
      const url = `<a href="${this.getPrivacyPolicyUrl()}" target="_blank">${this.$i18n.t('Cart.PrivacyPolicy')}</a>`

      forEach(this.$i18n.t('Cart.PrivacyTerms'), (str) => {
        ret.push(`${str.replace(/\{privacyPolicy\}/, url)}`)
      })
      return join(ret, '<br>')
    },
    initView: function () {
      this.text.CouponExcluded = this.$i18n.t('Cart.CouponExcluded')
      this.text.NotApplying = this.$i18n.t('Cart.NotApplying')
      this.text.UseCoupon = this.$i18n.t('Cart.UseCoupon')
    },
    // 初期化処理
    init: function () {
      // error.quantityを設定する
      if (this.getCart.item_list.length > 0) {
        for (let i = 0; i < this.getCart.item_list.length; i++) {
          this.errors.quantity.push({ msg: null })
        }
      }
      // セッションで保持しているメールアドレスをセットする
      if (sessionStorage.getItem('email') !== null && sessionStorage.getItem('email').length > 0) {
        this.mailaddress = this.CryptoJS.AES.decrypt(sessionStorage.getItem('email'), process.env.VUE_APP_EMAIL_HASHKEY).toString(this.CryptoJS.enc.Utf8)
      }
    }
  },
  // onload
  beforeMount () {
    // サーバー時間
    this.serverTime = this.getServerTime
    this.init()
    // 金額計算
    this.calculation()
  },
  mounted () {
    window.addEventListener('scroll', this.execScroll) // スクロールイベントを検知
    this.initView()
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.execScroll) // 画面を離れた際にスクロールイベントを削除する
  },
  beforeUpdate () {
    this.restoreScaleRate('default') // 拡大縮小のロックを開放
  },
  destroyed () {
    this.restoreScaleRate('reset') // scaleをリセット
  }
}
</script>

<style scoped>
.validation-error {
  color: #f00;
  display: block;
}
.align-right {
  text-align: right;
}
.pointer {
  cursor: pointer;
}
.hidden {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Cart.vue